import { render } from "./successModal.vue?vue&type=template&id=284d040e&lang=html"
import script from "./successModal.vue?vue&type=script&lang=js"
export * from "./successModal.vue?vue&type=script&lang=js"

import "./successModal.vue?vue&type=style&index=0&id=284d040e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__